"use strict";

var _toConsumableArray = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty2 = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var colors = _interopRequireWildcard(require("@material-ui/core/colors"));

var _createPalette = _interopRequireDefault(require("@material-ui/core/styles/createPalette"));

var _darkBlue = _interopRequireDefault(require("./colors/darkBlue"));

var _cerise = _interopRequireDefault(require("./colors/cerise"));

var _moneyGreen = _interopRequireDefault(require("./colors/moneyGreen"));

var _amber = _interopRequireDefault(require("./colors/amber"));

var _cyan = _interopRequireDefault(require("./colors/cyan"));

var _green = _interopRequireDefault(require("./colors/green"));

var _lightBlue = _interopRequireDefault(require("./colors/lightBlue"));

var _lightGreen = _interopRequireDefault(require("./colors/lightGreen"));

var _lime = _interopRequireDefault(require("./colors/lime"));

var _orange = _interopRequireDefault(require("./colors/orange"));

var _yellow = _interopRequireDefault(require("./colors/yellow"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var common = colors.common,
    actualColors = _objectWithoutProperties(colors, ["common"]);

var toPalette = function toPalette(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      color = _ref2[1];

  return _defineProperty2({}, name, (0, _createPalette.default)({
    primary: color
  }));
};

var defaultColors = Object.assign.apply(Object, _toConsumableArray(Object.entries(actualColors).map(toPalette)));

var _default = _objectSpread({}, defaultColors, {
  cerise: (0, _createPalette.default)(_cerise.default),
  darkBlue: (0, _createPalette.default)(_darkBlue.default),
  moneyGreen: (0, _createPalette.default)(_moneyGreen.default),
  cyan: (0, _createPalette.default)(_cyan.default),
  amber: (0, _createPalette.default)(_amber.default),
  green: (0, _createPalette.default)(_green.default),
  lightBlue: (0, _createPalette.default)(_lightBlue.default),
  lightGreen: (0, _createPalette.default)(_lightGreen.default),
  lime: (0, _createPalette.default)(_lime.default),
  orange: (0, _createPalette.default)(_orange.default),
  yellow: (0, _createPalette.default)(_yellow.default)
});

exports.default = _default;